import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { formatDateTimeNoTz } from "@/filters";
import eventStatus from '@/components/eventStatus.vue';
import Pagination from '@/components/Pagination.vue';
import DataTable from '@intec/vue-components/table/DataTable.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogEventsGrid',
  props: {
  pageSizesList: {
    type: Object,
    required: true
  },
  tableModel: {
    type: Object,
    required: true
  },
  confirmDlg: {
    type: Object,
    required: true
  },
},
  setup(__props) {

const props = __props;

const viewLogs = async (event) => {
  await props.confirmDlg.open(event.id);
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DataTable, _mergeProps({
      "loading-text": "Загрузка данных...",
      "no-data-text": "Нет данных"
    }, props.tableModel.bind, _toHandlers(props.tableModel.on), {
      page: props.tableModel.bind.options.page,
      "hide-default-footer": ""
    }), {
      item: _withCtx(({ item }) => [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(item.id), 1 /* TEXT */),
          _createElementVNode("td", null, _toDisplayString(_unref(formatDateTimeNoTz)(item.createdAt)), 1 /* TEXT */),
          _createElementVNode("td", null, _toDisplayString(item.event?.name), 1 /* TEXT */),
          _createElementVNode("td", null, _toDisplayString(item.madeBy?.username), 1 /* TEXT */),
          _createElementVNode("td", null, [
            _createVNode(eventStatus, {
              isSuccess: item.success,
              value: _ctx.$t(item.success ? 'Успешно' : 'Неудачно')
            }, null, 8 /* PROPS */, ["isSuccess", "value"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_v_menu, {
              transition: "slide-x-transition",
              location: "bottom left",
              "open-on-hover": true,
              "close-on-content-click": false
            }, {
              activator: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "px-0 action-button-color",
                  icon: "custom:eyeOutlineIcon",
                  onClick: ($event: any) => (viewLogs(item))
                }, null, 8 /* PROPS */, ["onClick"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["page"]),
    _createVNode(Pagination, {
      "page-sizes-list": props.pageSizesList,
      "table-model": props.tableModel
    }, null, 8 /* PROPS */, ["page-sizes-list", "table-model"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})